(function () {
	function qsa(root, selector) {
		return Array.prototype.slice.call(root.querySelectorAll(selector));
	}

	function getWishlist() {
		try {
			return JSON.parse(localStorage.getItem('kc-wishlist') || '[]');
		} catch (err) {
			return [];
		}
	}

	function setWishlist(list) {
		try {
			localStorage.setItem('kc-wishlist', JSON.stringify(list));
		} catch (err) { /* ignore */ }
	}

	function initWishlistButtons(root) {
		qsa(root, '[data-kc-plp-wishlist]').forEach(function (btn) {
			if (btn.__kcPlpReady) return;
			btn.__kcPlpReady = true;
			var handle = btn.getAttribute('data-handle');
			function refresh() {
				var active = getWishlist().indexOf(handle) > -1;
				btn.classList.toggle('is-active', active);
				btn.setAttribute('aria-pressed', active ? 'true' : 'false');
			}
			btn.addEventListener('click', function (event) {
				event.preventDefault();
				event.stopPropagation();
				var list = getWishlist();
				var index = list.indexOf(handle);
				if (index > -1) {
					list.splice(index, 1);
				} else {
					list.push(handle);
				}
				setWishlist(list);
				refresh();
			});
			refresh();
		});
	}

	function addToCart(id) {
		// Always a plain fetch, never window.themeCore.CartApi — see the
		// same note in assets/kc-product.js.
		return fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
		});
	}

	function flashQuickAdd(button, label, ok) {
		var span = button.querySelector('[data-kc-plp-quickadd-label]') || button.querySelector('span');
		var original = span ? span.textContent : '';
		button.classList.add(ok ? 'is-added' : 'is-error');
		if (span) span.textContent = label;
		button.disabled = true;
		window.setTimeout(function () {
			button.classList.remove('is-added', 'is-error');
			if (span) span.textContent = original;
			button.disabled = false;
		}, ok ? 1600 : 1200);
	}

	function initQuickAdd(root) {
		qsa(root, '[data-kc-plp-quickadd]').forEach(function (button) {
			if (button.__kcPlpReady) return;
			button.__kcPlpReady = true;
			button.addEventListener('click', function (event) {
				event.preventDefault();
				event.stopPropagation();
				if (button.disabled) return;
				var id = button.getAttribute('data-variant-id');
				addToCart(id)
					.then(function () {
						flashQuickAdd(button, ((window.KC_I18N && KC_I18N.added) || 'Added ✓'), true);
						document.dispatchEvent(new CustomEvent('kc:cart:added'));
					})
					.catch(function (err) {
						flashQuickAdd(button, ((window.KC_I18N && KC_I18N.error) || 'Something went wrong'), false);
						window.console && console.error && console.error('kc-plp quick add failed', err);
					});
			});
		});

		qsa(root, '[data-kc-plp-quickadd-toggle]').forEach(function (toggle) {
			if (toggle.__kcPlpReady) return;
			toggle.__kcPlpReady = true;
			var card = toggle.closest('.kc-plp-card');
			var panel = card ? card.querySelector('[data-kc-plp-variant-panel]') : null;
			if (!panel) return;

			function closePanel() {
				panel.hidden = true;
				toggle.setAttribute('aria-expanded', 'false');
				document.removeEventListener('click', onOutsideClick, true);
				document.removeEventListener('keydown', onKeydown, true);
			}
			function openPanel() {
				panel.hidden = false;
				toggle.setAttribute('aria-expanded', 'true');
				document.addEventListener('click', onOutsideClick, true);
				document.addEventListener('keydown', onKeydown, true);
			}
			function onOutsideClick(event) {
				if (!panel.contains(event.target) && event.target !== toggle) {
					closePanel();
				}
			}
			function onKeydown(event) {
				if (event.key === 'Escape') closePanel();
			}

			toggle.addEventListener('click', function (event) {
				event.preventDefault();
				event.stopPropagation();
				if (panel.hidden) {
					openPanel();
				} else {
					closePanel();
				}
			});

			var closeButton = panel.querySelector('[data-kc-plp-variant-close]');
			if (closeButton) {
				closeButton.addEventListener('click', function (event) {
					event.preventDefault();
					event.stopPropagation();
					closePanel();
				});
			}

			qsa(panel, '[data-kc-plp-variant-id]').forEach(function (variantButton) {
				variantButton.addEventListener('click', function (event) {
					event.preventDefault();
					event.stopPropagation();
					if (variantButton.disabled) return;
					var id = variantButton.getAttribute('data-kc-plp-variant-id');
					addToCart(id)
						.then(function () {
							variantButton.textContent = '✓';
							document.dispatchEvent(new CustomEvent('kc:cart:added'));
							window.setTimeout(closePanel, 900);
						})
						.catch(function (err) {
							window.console && console.error && console.error('kc-plp quick add failed', err);
						});
				});
			});
		});
	}

	function initCards(root) {
		initWishlistButtons(root);
		initQuickAdd(root);
	}

	// --- Section fetch + swap ---------------------------------------------------

	function sectionUrl(baseUrl, sectionId) {
		var separator = baseUrl.indexOf('?') > -1 ? '&' : '?';
		return baseUrl + separator + 'section_id=' + encodeURIComponent(sectionId);
	}

	function fetchSectionDoc(baseUrl, sectionId) {
		return fetch(sectionUrl(baseUrl, sectionId))
			.then(function (response) { return response.text(); })
			.then(function (html) {
				return new DOMParser().parseFromString(html, 'text/html');
			});
	}

	function initPlpSection(root) {
		if (root.__kcPlpSectionReady) return;
		root.__kcPlpSectionReady = true;

		var sectionId = root.getAttribute('data-section-id');
		initCards(root);

		function swapWith(doc, newUrl) {
			var newSection = doc.querySelector('[data-kc-plp-section]');
			if (!newSection) return;

			var parent = root.parentNode;
			parent.replaceChild(newSection, root);

			var currentDrawer = document.querySelector('[data-kc-filter-drawer]');
			var newDrawer = doc.querySelector('[data-kc-filter-drawer]');
			if (currentDrawer && newDrawer) {
				currentDrawer.parentNode.replaceChild(newDrawer, currentDrawer);
			}

			if (newUrl) {
				history.replaceState(null, '', newUrl);
			}
			initPlpSectionFresh(newSection);
		}

		function fullSwap(url, pushUrl) {
			return fetchSectionDoc(url, sectionId).then(function (doc) {
				swapWith(doc, pushUrl || url);
			});
		}

		// --- Sort dropdown -------------------------------------------------------
		var sortWrap = root.querySelector('[data-kc-plp-sort]');
		if (sortWrap) {
			var sortToggle = sortWrap.querySelector('[data-kc-plp-sort-toggle]');
			var sortMenu = sortWrap.querySelector('[data-kc-plp-sort-menu]');

			function closeSort() {
				sortMenu.hidden = true;
				sortToggle.setAttribute('aria-expanded', 'false');
			}
			function openSort() {
				sortMenu.hidden = false;
				sortToggle.setAttribute('aria-expanded', 'true');
			}

			sortToggle.addEventListener('click', function (event) {
				event.stopPropagation();
				if (sortMenu.hidden) openSort(); else closeSort();
			});
			document.addEventListener('click', function (event) {
				if (!sortWrap.contains(event.target)) closeSort();
			});
			document.addEventListener('keydown', function (event) {
				if (event.key === 'Escape') closeSort();
			});

			qsa(sortMenu, '[data-kc-plp-sort-option]').forEach(function (link) {
				link.addEventListener('click', function (event) {
					event.preventDefault();
					closeSort();
					var params = new URLSearchParams(window.location.search);
					params.delete('page');
					params.set('sort_by', link.getAttribute('data-value'));
					fullSwap(window.location.pathname + '?' + params.toString());
				});
			});
		}

		// --- Active filter chips ---------------------------------------------------
		qsa(root, '[data-kc-plp-chip-remove]').forEach(function (chip) {
			chip.addEventListener('click', function (event) {
				event.preventDefault();
				fullSwap(chip.getAttribute('href'));
			});
		});

		// --- Load more ---------------------------------------------------------------
		var loadMoreButton = root.querySelector('[data-kc-plp-loadmore-button]');
		if (loadMoreButton) {
			loadMoreButton.addEventListener('click', function (event) {
				event.preventDefault();
				var nextUrl = loadMoreButton.getAttribute('data-next-url');
				if (!nextUrl || loadMoreButton.disabled) return;

				var originalText = loadMoreButton.textContent;
				loadMoreButton.textContent = ((window.KC_I18N && KC_I18N.loading) || 'LOADING …');
				loadMoreButton.disabled = true;

				fetchSectionDoc(nextUrl, sectionId).then(function (doc) {
					var newSection = doc.querySelector('[data-kc-plp-section]');
					if (!newSection) return;

					var grid = root.querySelector('[data-kc-plp-grid]');
					var newProducts = qsa(newSection, '[data-kc-plp-grid] > [data-kc-plp-product]');
					newProducts.forEach(function (li) {
						grid.appendChild(li);
					});
					initCards(grid);

					var currentLoadMore = root.querySelector('[data-kc-plp-loadmore]');
					var newLoadMore = newSection.querySelector('[data-kc-plp-loadmore]');
					if (currentLoadMore && newLoadMore) {
						var countEl = currentLoadMore.querySelector('[data-kc-plp-loadmore-count]');
						var newCountEl = newLoadMore.querySelector('[data-kc-plp-loadmore-count]');
						if (countEl && newCountEl) countEl.textContent = newCountEl.textContent;

						var fillEl = currentLoadMore.querySelector('[data-kc-plp-loadmore-fill]');
						var newFillEl = newLoadMore.querySelector('[data-kc-plp-loadmore-fill]');
						if (fillEl && newFillEl) fillEl.style.width = newFillEl.style.width;

						var newButton = newLoadMore.querySelector('[data-kc-plp-loadmore-button]');
						if (newButton) {
							loadMoreButton.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
							loadMoreButton.textContent = originalText;
							loadMoreButton.disabled = false;
						} else {
							currentLoadMore.setAttribute('hidden', '');
						}
					}

					history.replaceState(null, '', nextUrl);
				});
			});
		}

		// --- Filter drawer -----------------------------------------------------------
		var drawer = document.querySelector('[data-kc-filter-drawer]');
		var openButton = root.querySelector('[data-kc-plp-filter-open]');
		if (drawer && openButton) {
			var backdrop = drawer.querySelector('[data-kc-filter-drawer-backdrop]');
			var closeButton = drawer.querySelector('[data-kc-filter-drawer-close]');
			var clearButton = drawer.querySelector('[data-kc-filter-drawer-clear]');
			var applyButton = drawer.querySelector('[data-kc-filter-drawer-apply]');
			var countEl = drawer.querySelector('[data-kc-filter-drawer-count]');
			var previewTimer = null;

			function baseParams() {
				var params = new URLSearchParams(window.location.search);
				var toDelete = [];
				params.forEach(function (value, key) {
					if (key.indexOf('filter.') === 0 || key === 'page') toDelete.push(key);
				});
				toDelete.forEach(function (key) { params.delete(key); });
				return params;
			}

			function pendingParams() {
				var params = baseParams();
				qsa(drawer, '[data-kc-filter-input]:checked').forEach(function (input) {
					params.append(input.name, input.value);
				});
				var priceMin = drawer.querySelector('[data-kc-filter-price-min]');
				var priceMax = drawer.querySelector('[data-kc-filter-price-max]');
				if (priceMin && priceMin.value) params.set(priceMin.getAttribute('data-param'), Math.round(parseFloat(priceMin.value) * 100));
				if (priceMax && priceMax.value) params.set(priceMax.getAttribute('data-param'), Math.round(parseFloat(priceMax.value) * 100));
				return params;
			}

			function pendingUrl() {
				var params = pendingParams();
				var query = params.toString();
				return window.location.pathname + (query ? '?' + query : '');
			}

			function refreshLiveCount() {
				window.clearTimeout(previewTimer);
				previewTimer = window.setTimeout(function () {
					fetchSectionDoc(pendingUrl(), sectionId).then(function (doc) {
						if (!countEl) return;
						var newCount = doc.querySelector('[data-kc-filter-drawer-count]');
						if (newCount) countEl.textContent = newCount.textContent;
					});
				}, 200);
			}

			qsa(drawer, '[data-kc-filter-input]').forEach(function (input) {
				input.addEventListener('change', refreshLiveCount);
			});
			qsa(drawer, '[data-kc-filter-price-min], [data-kc-filter-price-max]').forEach(function (input) {
				input.addEventListener('input', refreshLiveCount);
			});

			function trapFocus(event) {
				if (event.key !== 'Tab') return;
				var focusable = qsa(drawer, 'a, button, input, [tabindex]').filter(function (el) {
					return !el.disabled && el.offsetParent !== null;
				});
				if (!focusable.length) return;
				var first = focusable[0];
				var last = focusable[focusable.length - 1];
				if (event.shiftKey && document.activeElement === first) {
					event.preventDefault();
					last.focus();
				} else if (!event.shiftKey && document.activeElement === last) {
					event.preventDefault();
					first.focus();
				}
			}

			function onDrawerKeydown(event) {
				if (event.key === 'Escape') closeDrawer();
				trapFocus(event);
			}

			function openDrawer() {
				drawer.hidden = false;
				requestAnimationFrame(function () { drawer.classList.add('is-open'); });
				document.addEventListener('keydown', onDrawerKeydown);
				var firstFocusable = drawer.querySelector('a, button, input');
				if (firstFocusable) firstFocusable.focus();
			}
			function closeDrawer() {
				drawer.classList.remove('is-open');
				document.removeEventListener('keydown', onDrawerKeydown);
				window.setTimeout(function () { drawer.hidden = true; }, 300);
				openButton.focus();
			}

			openButton.addEventListener('click', openDrawer);
			if (closeButton) closeButton.addEventListener('click', closeDrawer);
			if (backdrop) backdrop.addEventListener('click', closeDrawer);

			if (clearButton) {
				clearButton.addEventListener('click', function () {
					qsa(drawer, '[data-kc-filter-input]').forEach(function (input) { input.checked = false; });
					var priceMin = drawer.querySelector('[data-kc-filter-price-min]');
					var priceMax = drawer.querySelector('[data-kc-filter-price-max]');
					if (priceMin) priceMin.value = '';
					if (priceMax) priceMax.value = '';
					refreshLiveCount();
				});
			}

			if (applyButton) {
				applyButton.addEventListener('click', function () {
					fullSwap(pendingUrl()).then(function () {
						var reopened = document.querySelector('[data-kc-filter-drawer]');
						if (reopened) reopened.hidden = true;
					});
				});
			}
		}
	}

	function initPlpSectionFresh(root) {
		root.__kcPlpSectionReady = false;
		initPlpSection(root);
	}

	function initAll(scope) {
		scope = scope || document;
		qsa(scope, '[data-kc-plp-section]').forEach(initPlpSection);
		if (scope.matches && scope.matches('[data-kc-plp-section]')) initPlpSection(scope);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { initAll(); });
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});

	// Reused by kc-search-results.js for real product cards rendered outside
	// a [data-kc-plp-section] wrapper (the wishlist/quick-add wiring is the
	// same everywhere; filtering/sorting/load-more stay PLP-only).
	window.kcPlpCards = { init: initCards };
})();
